declare global {
  interface Window {
    dev: () => boolean;
    hasRemote: () => boolean;
    hasMode: (mode) => boolean;
    mode: string;
    reviewModeEnabled: boolean;
    savedStore: any;
    locationHistory: string | null;
    persistHistory: boolean;
    IS_CHAMELEON_MODULE: boolean;
    chameleon: any;
    fonts: any;
    FontFace: any;
  }
  interface Document {
    fonts: any;
  }
}

import './setup';

import 'assets/whoopsBrowserIncompatible.png';
import { ErrorBoundary } from 'components/errorHandler';
import ModuleImagesPreloader from 'components/lib/PreLoaders/ModuleImagesPreloader';
import Module from 'components/Module';
import { HostingProvider } from 'hosting/context';
//
import React, { FC, Fragment as _ } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'regenerator-runtime/runtime.js';
import { addFont } from 'services/fontService';
import getModuleImages from 'services/getModuleImages';
import getStore from 'services/getStore';
import 'services/scorm/scormService';
import smoothscroll from 'smoothscroll-polyfill';
import 'styles/global';
import 'whatwg-fetch';

if (!('IntersectionObserver' in window)) {
  require('intersection-observer');
}

smoothscroll.polyfill();

window.hasRemote = () => getParams().hasRemote;

window.dev = () => {
  try {
    return window.parent.IS_CHAMELEON_EDITOR;
  } catch (err) {
    //
  }

  return ['DEVELOPMENT', 'EDIT'].includes(window?.mode);
};

// disable all react-beautiful-dnd development warnings
window['__react-beautiful-dnd-disable-dev-warnings'] = true;

const store = getStore();

try {
  window.hasMode = mode => {
    const windowMode = window.mode || 'DEVELOPMENT';
    return mode === windowMode;
  };

  window.client = parent.client;
} catch (err) {
  // console.warn(err);
}

const loadTheme = store.subscribe(() => {
  const {
    backgroundColor = '',
    fontFamily = '',
    fontSizes,
    fontFamilies = [],
  } = store.getState().theme;

  document.body.style.background = backgroundColor;

  if (!!fontFamilies.length) {
    fontFamilies.forEach(f => {
      addFont(f);
    });
  }

  // just wanting to smash this until it displays for sure
  if (fontFamily) {
    const checkFontFamilyDisplays = setInterval(() => {
      if (document.body.style.fontFamily.includes(fontFamily)) {
        clearInterval(checkFontFamilyDisplays);
      }

      document.body.style.fontFamily = fontFamily;
    }, 0);
  }

  loadTheme.unsubscribe && loadTheme.unsubscribe();
});

const isHosted = (window as any).getParams().hosted;
const ccURL = (window as any).chameleon.CHAMELEON_URL;

const HostingWrapper: FC = ({ children }) => {
  if (isHosted) {
    const projectId = (window as any).getParams().projectId;

    return (
      <HostingProvider url={ccURL} projectId={projectId}>
        {children}
      </HostingProvider>
    );
  }

  return <>{children}</>;
};

const moduleImages = getModuleImages();

// console.log(window.location.hash);
const location = window.location.hash;
if (location) {
  window.location.hash = '#';
  window.location.hash = location;
  // something
}

ReactDOM.render(
  <_>
    <ErrorBoundary>
      <HostingWrapper>
        <Provider store={store}>
          <Module />

          {(window.dev() || store.getState()?.theme?.useImagePreloader) && (
            <ModuleImagesPreloader images={moduleImages} />
          )}
        </Provider>
      </HostingWrapper>
    </ErrorBoundary>
  </_>,
  document.querySelector('#root')
);
